import type { BaseColumns } from "../types.js";

/** Instant airdrop: address, amount (no vesting) */
export type InstantColumns = BaseColumns;

export type Columns = InstantColumns;
